import React from 'react';
import { Container, Grid } from '@material-ui/core';
import { GridExport, GridGeneration, GridRegion, GridSetting, GridWgra } from './components'
// ========================================

export default function InstallationPage (props) {
  const { readonly = false } = props;

  return (
    <Container maxWidth="lg">
      <Grid container justify="space-between" spacing={1}>
        <GridRegion readonly={readonly} />
        <GridExport readonly={readonly} />
        <GridGeneration readonly={readonly} />
        <GridWgra readonly={readonly} />
        <GridSetting readonly={readonly} />
      </Grid>
    </Container>
  );
}
